export const UpdateValueInArrayOfObject = (prevItems, fieldCompare, valueCompare, field, newValue) => {
  return prevItems.map((item) => (item[fieldCompare] === valueCompare ? { ...item, [field]: newValue } : item))
}

export const DeleteValueInArrayOfObject = (prevItems, fieldCompare, valueCompare) => {
  return prevItems.map((item) => (item[fieldCompare] !== valueCompare ? item : null)).filter((item) => item !== null)
}
